import JwtDecode from 'jwt-decode';

/**
 * 로그인 토큰에 있는 유저 정보를 decode
 * @returns {any} : JSON 형태의 decode 된 정보
 */
const parseLoginToken = () => {
  var token = localStorage.getItem('token');
  return token ? JSON.parse(JwtDecode(token).details) : null;
};

// 모바일 여부 확인
const isMobile = () => {
  return !!(
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  );
};

// Delete ToPath:KEY
const pathReplace = (arr, path, eject) => {
  if (path !== '/client/claim_information/create' && path !== '/client/claim_information/update') {
    Object.keys(arr).forEach((k) => {
      if (arr[k] && k !== eject) {
        path = path.replace(`/${arr[k]}`, '');
      }
    });
  }
  return path;
};

const excalDownload = (method, url, data, filename) => {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();
    let params = '?';
    if (method === 'GET') {
      Object.keys(data).map((d) => {
        params += `${d}=${data[d]}&`;
      });
    }
    xhr.open(method, process.env.BASE_API_URL + url + params.slice(0, -1));
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('authorization', `Bearer ${localStorage.getItem('token')}`);
    xhr.responseType = 'blob';
    xhr.onload = (e) => {
      if (e.currentTarget.status === 200) {
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(e.currentTarget.response);
        link.download = `${filename}.xls`;
        link.click();
        resolve();
      } else {
        reject(e);
      }
    };

    xhr.send(JSON.stringify(data));
  });
};

/*
  객체에서 원하는 키값을 뽑아내는 함수
 */
const getValueOfField = (obj, field, emptyText = '') => {
  if (Object.keys(obj).length === 0) return emptyText;

  const idx = field.indexOf('.');

  if (idx === -1) {
    return obj[field];
  } else {
    const nextObj = obj[field.slice(0, idx)];
    const nextField = field.slice(idx + 1);

    return getValueOfField(nextObj, nextField);
  }
};

const replaceNewLine = (content) => {
  return content.replace(/(?:\r\n|\r|\n)/g, '<br/>');
};

export { parseLoginToken, isMobile, pathReplace, excalDownload, getValueOfField, replaceNewLine };



// WEBPACK FOOTER //
// ./src/util/index.js